import { Link } from "react-router-dom";
import { ArrowLeft, FileText } from "lucide-react";

const TermsPage = () => {
  return (
    <div className="pt-20 min-h-screen bg-slate-50">
      {/* Header */}
      <div className="bg-gradient-to-r from-navy-600 to-navy-700 py-8">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-white/80 hover:text-white mb-4 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to Home
          </Link>
          <div className="flex items-center gap-3">
            <FileText className="w-8 h-8 text-white" />
            <h1 className="text-3xl font-bold text-white">Terms and Conditions</h1>
          </div>
          <p className="text-navy-200 mt-2">Last updated: January 6, 2025</p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
          <div className="prose prose-slate max-w-none">
            <h2 className="text-2xl font-bold text-navy-900 mb-4">1. Agreement to Terms</h2>
            <p className="text-slate-600 mb-6">
              By accessing or using the My Insurance Coverage website and services, you agree to be bound by these Terms and Conditions. If you disagree with any part of these terms, you may not access our services.
            </p>

            <h2 className="text-2xl font-bold text-navy-900 mb-4">2. Insurance Services</h2>
            <p className="text-slate-600 mb-4">
              My Insurance Coverage acts as a licensed insurance agent/broker. We provide:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-6 space-y-2">
              <li>Insurance quotes and policy information</li>
              <li>Assistance in selecting appropriate coverage</li>
              <li>Policy servicing and support</li>
              <li>Claims assistance guidance</li>
            </ul>
            <p className="text-slate-600 mb-6">
              All insurance policies are underwritten by third-party insurance carriers. We do not guarantee coverage or make binding decisions on behalf of insurance carriers.
            </p>

            <h2 className="text-2xl font-bold text-navy-900 mb-4">3. Quote Requests</h2>
            <p className="text-slate-600 mb-6">
              When you submit a quote request through our website, you agree that:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-6 space-y-2">
              <li>All information provided is accurate and complete to the best of your knowledge</li>
              <li>We may contact you via phone, email, or text message regarding your request</li>
              <li>Quotes are estimates only and final premiums may vary based on underwriting</li>
              <li>Quote availability and pricing are subject to change without notice</li>
            </ul>

            <h2 className="text-2xl font-bold text-navy-900 mb-4">4. User Responsibilities</h2>
            <p className="text-slate-600 mb-4">
              You are responsible for:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-6 space-y-2">
              <li>Providing accurate and truthful information in all communications</li>
              <li>Reviewing policy documents carefully before purchasing</li>
              <li>Maintaining the confidentiality of any account credentials</li>
              <li>Notifying us of any changes that may affect your coverage</li>
            </ul>

            <h2 className="text-2xl font-bold text-navy-900 mb-4">5. Intellectual Property</h2>
            <p className="text-slate-600 mb-6">
              All content on this website, including text, graphics, logos, and software, is the property of Bradley Greenberg Insurance or its content suppliers and is protected by copyright laws. You may not reproduce, distribute, or create derivative works without our express written consent.
            </p>

            <h2 className="text-2xl font-bold text-navy-900 mb-4">6. Disclaimer of Warranties</h2>
            <p className="text-slate-600 mb-6">
              Our website and services are provided "as is" without warranties of any kind, either express or implied. We do not warrant that the service will be uninterrupted, secure, or error-free. Insurance coverage is subject to the terms, conditions, and exclusions of each individual policy.
            </p>

            <h2 className="text-2xl font-bold text-navy-900 mb-4">7. Limitation of Liability</h2>
            <p className="text-slate-600 mb-6">
              To the fullest extent permitted by law, My Insurance Coverage shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of our services. Our total liability shall not exceed the amount of any fees paid by you for services in the twelve months preceding the claim.
            </p>

            <h2 className="text-2xl font-bold text-navy-900 mb-4">8. Third-Party Links</h2>
            <p className="text-slate-600 mb-6">
              Our website may contain links to third-party websites, including insurance carrier websites. We are not responsible for the content, privacy policies, or practices of these external sites. Access to third-party sites is at your own risk.
            </p>

            <h2 className="text-2xl font-bold text-navy-900 mb-4">9. Governing Law</h2>
            <p className="text-slate-600 mb-6">
              These Terms shall be governed by and construed in accordance with the laws of the State of New Jersey, without regard to its conflict of law provisions. Any disputes shall be resolved in the courts of New Jersey.
            </p>

            <h2 className="text-2xl font-bold text-navy-900 mb-4">10. Changes to Terms</h2>
            <p className="text-slate-600 mb-6">
              We reserve the right to modify these terms at any time. Changes will be effective immediately upon posting to this website. Your continued use of our services after changes are posted constitutes acceptance of the modified terms.
            </p>

            <h2 className="text-2xl font-bold text-navy-900 mb-4">11. Contact Information</h2>
            <p className="text-slate-600 mb-4">
              For questions about these Terms and Conditions, please contact us:
            </p>
            <div className="bg-slate-50 p-6 rounded-xl">
              <p className="text-slate-700"><strong>My Insurance Coverage</strong></p>
              <p className="text-slate-600">Phone: (201) 227-6413</p>
              <p className="text-slate-600">Email: bgreenberg@acrisure.com</p>
            </div>
          </div>
        </div>

        {/* Back to top */}
        <div className="mt-8 text-center">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 bg-navy-600 text-white font-semibold rounded-full hover:bg-navy-700 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
